import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Model from "./model";

export default class Parking extends Model {
  _uid;
  _raw;
  createdAt;
  communityRef;
  ownerRef;
  _ownershipCertificatePath;
  _picturePath;
  schedule;
  available;
  spotNumber;
  certificateURL;
  pictureURL;

  /**
   * Constructor for Parking
   * @param {{
   *   raw: firebase.firestore.DocumentReference,
   *   createdAt: firebase.firestore.Timestamp,
   *   communityRef: firebase.firestore.DocumentReference,
   *   ownerRef: firebase.firestore.DocumentReference,
   *   ownershipCertificatePath: string,
   *   picturePath: string,
   *   schedule: string,
   *   available: boolean,
   *   spotNumber: number,
   *   certificateURL: string,
   *   pictureURL: string
   * }} hydration
   */
  constructor(hydration) {
    super();
    this.hydrate(hydration);
  }

  get id() {
    return this._uid;
  }

  hydrate({
    type,
    raw,
    createdAt,
    communityRef,
    ownerRef,
    ownershipCertificatePath,
    picturePath,
    schedule,
    available,
    spotNumber,
    certificateURL,
    pictureURL
  }) {
    this._uid = raw.id;
    this._raw = raw;
    this.createdAt = createdAt;
    this.communityRef = communityRef;
    this.ownerRef = ownerRef;
    this._ownershipCertificatePath = ownershipCertificatePath;
    this._picturePath = picturePath;
    this.schedule = schedule;
    this.available = available;
    this.spotNumber = spotNumber;
    this.certificateURL = certificateURL;
    this.pictureURL = pictureURL;
    this.type = type;
    this._selfRef = this._raw;
  }

  static async buildHydration(snapshot) {
    const data = snapshot.data();
    const storageRef = firebase.storage().ref();
    let certificateRef, certificateURL;
    const pictureRef = storageRef.child(data.picture);
    const pictureURL = pictureRef.getDownloadURL();
    if (data.ownershipCertificate) {
      certificateRef = storageRef.child(data.ownershipCertificate);
      certificateURL = certificateRef.getDownloadURL();
    }
    return {
      raw: snapshot.ref,
      type: data.type,
      createdAt: data.createdAt,
      communityRef: data.community,
      ownerRef: data.createdBy,
      ownershipCertificatePath: data.ownershipCertificate,
      picturePath: data.picture,
      schedule: data.schedule,
      available: data.available,
      spotNumber: data.spotNumber,
      certificateURL: await certificateURL,
      pictureURL: await pictureURL
    };
  }

  async getCommunityDoc() {
    const snapshot = await this.communityRef.get();
    if (snapshot.exists) return snapshot.data();
    return undefined;
  }

  async getOwnerDoc() {
    const snapshot = await this.ownerRef.get();
    if (snapshot.exists) return snapshot.data();
    return undefined;
  }
}
